import { getLenis } from './smoothScroll';

let lockCount = 0;
let scrollPosition = 0;

const isBrowser = typeof window !== 'undefined';

export const lockScroll = () => {
  if (!isBrowser) return;
  if (lockCount === 0) {
    scrollPosition = window.scrollY;
    const { body, documentElement } = document;

    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    documentElement.style.overscrollBehavior = 'none';

    // Pause smooth scroll (if running) so Lenis doesn't fight the fixed-body lock
    // or capture wheel events meant for the modal's own scroll area. The modal's
    // inner scroller carries data-lenis-prevent, so it keeps scrolling natively
    // even while Lenis is stopped (verified against lenis@1.3.x: the prevent check
    // short-circuits before Lenis calls preventDefault). No-op when Lenis is null.
    getLenis()?.stop();
  }
  lockCount += 1;
};

export const unlockScroll = () => {
  if (!isBrowser || lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    const { body, documentElement } = document;
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    body.style.overflow = '';
    documentElement.style.overscrollBehavior = '';
    window.scrollTo(0, scrollPosition);

    // Resume smooth scroll and re-sync Lenis to the restored position. We must NOT
    // use lenis.scrollTo() here: while the body was position:fixed the document's
    // scrollable height collapsed, so Lenis's cached dimensions.limit is ~0 and
    // scrollTo would clamp the target to 0 and yank the page to the top. Instead:
    //   start()  -> clears the stopped state; its internal reset() re-syncs
    //               animatedScroll/targetScroll to the native scrollY we just
    //               restored above (scrollPosition).
    //   resize() -> recomputes dimensions (limit) now that the fixed body is gone,
    //               and re-syncs scroll again, so subsequent wheeling isn't clamped.
    // No-op when Lenis is null (the native window.scrollTo above already restored).
    const lenis = getLenis();
    if (lenis) {
      lenis.start();
      lenis.resize();
    }
  }
};
